// extracted by mini-css-extract-plugin
export var page = "index-module--page--cf-U0";